import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import ModalShell from "./ModalShell";

export default function SupplierModal({ supplier, onClose, onSaved }) {
    const isEdit = !!supplier?.id;
    const [form, setForm] = useState({
        name: "", contact_person: "", email: "", phone: "", website: "",
        street: "", zip: "", city: "", country: "DE", ust_id: "",
        customer_number: "", payment_terms_days: 30, skonto_percent: 0,
        skonto_days: 0, discount_percent: 0, iban: "", bic: "", bank_name: "",
        notes: "", is_active: true, ...supplier,
    });
    const [busy, setBusy] = useState(false);
    const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));
    const submit = async (e) => {
        e.preventDefault();
        if (!form.name?.trim()) { toast.error("Name Pflicht"); return; }
        setBusy(true);
        try {
            const payload = { ...form };
            // strip non-API fields
            delete payload.id; delete payload.created_at; delete payload.updated_at; delete payload.dealer_id;
            // coerce numerics
            ["payment_terms_days", "skonto_days"].forEach((k) => payload[k] = Number(payload[k]) || 0);
            ["skonto_percent", "discount_percent"].forEach((k) => payload[k] = Number(payload[k]) || 0);
            if (isEdit) {
                await api.patch(`/suppliers/${supplier.id}`, payload);
            } else {
                await api.post("/suppliers", payload);
            }
            toast.success(isEdit ? "Lieferant aktualisiert" : "Lieferant angelegt");
            onSaved();
        } catch (e) { toast.error(e.response?.data?.detail || "Fehler"); }
        setBusy(false);
    };
    return (
        <ModalShell onClose={onClose} title={isEdit ? "Lieferant bearbeiten" : "Neuer Lieferant"} wide testid="supplier-modal">
            <form onSubmit={submit} className="space-y-3">
                <Input placeholder="Name / Firma *" value={form.name} onChange={(e) => setF("name", e.target.value)} className="rounded-sm" data-testid="sup-name" />
                <div className="grid grid-cols-2 gap-2">
                    <Input placeholder="Ansprechpartner" value={form.contact_person || ""} onChange={(e) => setF("contact_person", e.target.value)} className="rounded-sm" data-testid="sup-contact" />
                    <Input type="email" placeholder="E-Mail" value={form.email || ""} onChange={(e) => setF("email", e.target.value)} className="rounded-sm" data-testid="sup-email" />
                </div>
                <div className="grid grid-cols-2 gap-2">
                    <Input placeholder="Telefon" value={form.phone || ""} onChange={(e) => setF("phone", e.target.value)} className="rounded-sm" />
                    <Input placeholder="Website" value={form.website || ""} onChange={(e) => setF("website", e.target.value)} className="rounded-sm" />
                </div>
                <Input placeholder="Straße & Hausnummer" value={form.street || ""} onChange={(e) => setF("street", e.target.value)} className="rounded-sm" />
                <div className="grid grid-cols-3 gap-2">
                    <Input placeholder="PLZ" value={form.zip || ""} onChange={(e) => setF("zip", e.target.value)} className="rounded-sm" />
                    <Input placeholder="Stadt" value={form.city || ""} onChange={(e) => setF("city", e.target.value)} className="rounded-sm col-span-2" />
                </div>
                <div className="grid grid-cols-2 gap-2">
                    <Input placeholder="USt-IdNr." value={form.ust_id || ""} onChange={(e) => setF("ust_id", e.target.value)} className="rounded-sm" />
                    <Input placeholder="Kunden-Nr beim Lieferant" value={form.customer_number || ""} onChange={(e) => setF("customer_number", e.target.value)} className="rounded-sm" />
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-sm p-3 space-y-2">
                    <div className="text-xs font-bold uppercase tracking-wider text-gray-700">Konditionen</div>
                    <div className="grid grid-cols-4 gap-2">
                        <div>
                            <label className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Zahlungsziel (Tg)</label>
                            <Input type="number" min="0" max="180" value={form.payment_terms_days} onChange={(e) => setF("payment_terms_days", e.target.value)} className="rounded-sm" />
                        </div>
                        <div>
                            <label className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Skonto %</label>
                            <Input type="number" min="0" max="20" step="0.5" value={form.skonto_percent} onChange={(e) => setF("skonto_percent", e.target.value)} className="rounded-sm" />
                        </div>
                        <div>
                            <label className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Skonto-Tg</label>
                            <Input type="number" min="0" max="60" value={form.skonto_days} onChange={(e) => setF("skonto_days", e.target.value)} className="rounded-sm" />
                        </div>
                        <div>
                            <label className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Pauschal-Rabatt %</label>
                            <Input type="number" min="0" max="80" step="0.5" value={form.discount_percent} onChange={(e) => setF("discount_percent", e.target.value)} className="rounded-sm" />
                        </div>
                    </div>
                </div>
                <Textarea placeholder="Notizen" value={form.notes || ""} onChange={(e) => setF("notes", e.target.value)} className="rounded-sm min-h-[60px]" />
                <label className="flex items-center gap-2 text-sm">
                    <input type="checkbox" checked={form.is_active} onChange={(e) => setF("is_active", e.target.checked)} />
                    Aktiv
                </label>
                <Button type="submit" disabled={busy} className="w-full bg-[#111827] hover:bg-black text-white font-bold rounded-sm" data-testid="sup-submit">
                    {busy ? "Speichere…" : (isEdit ? "Aktualisieren" : "Lieferant anlegen")}
                </Button>
            </form>
        </ModalShell>
    );
}
